import { br_consentOptIn } from '../../../Events/BloomreachConsent.js';
const BloomreachDoubleOptIn = (() => {
  return {
    init() {
      this.handleDoubleOptIn();
    },

    getQueryParam(name) {
      try {
        return new URLSearchParams(window.location.search).get(name);
      } catch (e) {
        return null;
      }
    },

    isValidEmail(email) {
      return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    handleDoubleOptIn() {
      const br_double_opt_in = this.getQueryParam('br_double_opt_in');
      if (!br_double_opt_in) return;
      try {
        const email = window.atob(br_double_opt_in);
        if (!this.isValidEmail(email)) return;

        br_consentOptIn(email, true);

        const url = new URL(window.location.href);
        url.searchParams.delete('br_double_opt_in');
        history.replaceState(null, '', url.toString());

      } catch (e) {
        console.error('Bloomreach Double Opt-In: invalid encoding', e);
      }
    },
  };
})();

BloomreachDoubleOptIn.init();